import WMTSTileGrid from 'ol/tilegrid/WMTS'
import WMTS from 'ol/source/WMTS'
import axios from 'axios'
import uuid from 'uuid'
import { get as proj4get } from 'ol/proj'

const reqTemplate = (id, tokenUrl) => {
  return {
    method: 'post',
    url: tokenUrl,
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json'
    },
    withCredentials: true,
    data: JSON.stringify({
      data: {
        deviceId: id
      }
    })
  }
}
const timeLeft = (prevTime, expireTime) =>
  Math.floor(-(new Date().getTime() / 1000 - prevTime / 1000 - expireTime) / 60)

const remoteRequest = (request, handler) =>
  axios(request)
    .then(handler)
    .catch(err => console.error(err))

const buildDefaultOptUrl = (layer, style, matrixSet, version) =>
  `?layer=${layer}&style=${style}&tilematrixset=${matrixSet}&Service=WMTS&Request=GetTile&Version=${version}&Format=image%2Fjpeg`

/**
 * Data is used to store information about token handling
 * Data is loaded with "deviceIds" who will take turns to host a token from lantmäteriet
 * Data will eventually contain tokenInfo and the time when it got the new token to keep it up to date.
 */
export default ops => {
  // tokenUrl start
  let data = Object.assign({}, { deviceIds: [uuid(), uuid()], index: 0 })
  let tokenURL = ops.tokenUrl
  delete ops.tokenUrl
  let baseURL =
    ops.baseUrl ||
    'https://api.lantmateriet.se/open/topowebb-ccby/v1/wmts/token/'
  let layer =
    ops.layer || 'topowebb'

  let token = ops.token
  delete ops.token
  if (!ops.format) delete ops.format
  if (!ops.loader) delete ops.loader
  if (!ops.projection) delete ops.projection
  if (!ops.strategy) delete ops.strategy
  if (!ops.tileGrid) delete ops.tileGrid

  const defaultOptions = {
    url: `${baseURL}${token}/`,
    layer: layer,
    matrixSet: '3006',
    projection: proj4get('EPSG:3006'),
    tileGrid: new WMTSTileGrid({
      tileSize: 256,
      extent: [-1200000, 4700000, 2600000, 8500000],
      resolutions: [
        4096.0,
        2048.0,
        1024.0,
        512.0,
        256.0,
        128.0,
        64.0,
        32.0,
        16.0,
        8.0,
        4,
        2,
        1,
        0.5
      ],
      matrixIds: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]
    }),
    version: '1.0.0',
    style: 'default',
    crossOrigin: 'anonymous'
  }
  const options = Object.assign(defaultOptions, ops)
  let wmts = new WMTS(options)

  //TokenUrl init
  if (!!tokenURL) {
    const defaultOpt = buildDefaultOptUrl(
      options.layer,
      options.style,
      options.matrixSet,
      options.version
    )
    const urlTemplate = (x, y, z, token) =>
      `${baseURL}${token}/${defaultOpt}&TileMatrix=${z}&TileCol=${x}&TileRow=${y}`

    function handleNewToken(response) {
      data.index ^= 1
      data = Object.assign({}, data, {
        tokenInfo: response.data,
        time: new Date().getTime()
      })
      return response.data.access_token
    }

    let tokenLoader = remoteRequest(
      reqTemplate(data.deviceIds[data.index], tokenURL),
      handleNewToken
    )

    function getToken() {
      if (
        data &&
        data.tokenInfo &&
        data.tokenInfo.access_token &&
        timeLeft(data.time, data.tokenInfo.expires_in) >= 59
      ) {
        tokenLoader = null
        return Promise.resolve(data.tokenInfo.access_token)
      } else {
        if (tokenLoader === null) {
          tokenLoader = remoteRequest(
            reqTemplate(data.deviceIds[data.index], tokenURL),
            handleNewToken
          )
        }
        return tokenLoader
      }
    }

    function tileLoadFunc(imageTile, src) {
      let c = imageTile.getTileCoord()
      let z = c[0]
      let x = c[1]
      let y = c[2]

      getToken().then(token => {
        imageTile.getImage().src = urlTemplate(x, y, z, token)
      })
    }
    wmts.setTileLoadFunction(tileLoadFunc)
  }

  return wmts
}
